<template>
  <v-snackbar
    v-model="show"
    :multi-line="multiLine"
    :centered="centered"
    :timeout="time"
    :dark="$vuetify.theme.dark"
    :light="!$vuetify.theme.dark"
  >
    <p class="mb-0" v-if="text !== ''" v-html="text"></p>
    <p class="mb-0" v-if="lead !== ''" v-html="lead"></p>
    <template v-slot:action="{ attrs }">
      <v-btn
        :color="color"
        v-bind="attrs"
        @click="close()"
      >
        Fechar
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script>

export default {
  data () {
    return {
      show: this.$root.snackbar.show,
      time: this.$root.snackbar.time,
      text: this.$root.snackbar.text,
      lead: this.$root.snackbar.lead,
      multiLine: this.$root.snackbar.multiLine,
      centered: this.$root.snackbar.centered,
      color: this.$root.snackbar.color
    }
  },
  watch: {
    show () {
      this.close()
    }
  },
  methods: {
    close () {
      this.$root.snackbar.show = false
      this.$root.snackbar.text = ''
      this.$root.snackbar.lead = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SnackBar.vue